module.exports = __webpack_public_path__ + "static/media/rs2.9f832ff2.png";